import PageHero from "@/components/PageHero";
import SectionHeading from "@/components/SectionHeading";
import WorkshopCard from "@/components/WorkshopCard";
import NextArrow from "@/components/NextArrow";
import LocalizedLink from "@/components/LocalizedLink";
import { BookOpen, Presentation, Layers } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

const C = {
  ar: {
    eyebrow: "الورشات",
    title: "الورشات والبرامج التعليمية",
    lead: "يُدير مجتمع الذكاء الاصطناعي السوري نموذجًا تعليميًا عمليًا يُنفَّذ داخل الجامعات والمراكز المجتمعية، بصيغ متعدّدة تناسب الكليات، والمنظمات، والجهات المستضيفة، وتستخدم أدوات مجانية بالكامل.",
    modelEyebrow: "نموذج التنفيذ",
    modelTitle: "ثلاث صيغ لتنفيذ الجلسات التعليمية.",
    modelDesc: "نُصمّم كل جلسة بحسب احتياج الكلية أو الجهة المستضيفة؛ من محاضرة توعوية واحدة إلى سلسلة تدريبية متكاملة.",
    formats: [
      { icon: BookOpen, label: "محاضرة توعوية", desc: "جلسة واحدة تعريفية بالذكاء الاصطناعي وأدواته العملية، مناسبة للكليات التي تبحث عن مقدِّمة سريعة وواضحة.", duration: "جلسة واحدة" },
      { icon: Presentation, label: "ورشة تطبيقية", desc: "جلسة عملية تطبيقية تركّز على استخدام أدوات مجانية محدَّدة في الدراسة والبحث والمهام اليومية.", duration: "جلسة مُركَّزة" },
      { icon: Layers, label: "سلسلة تدريبية", desc: "مسار تدريبي متكامل يمتدّ على عدّة جلسات (4–6 جلسات)، مصمَّم للكليات والمراكز التي تطلب تغطية أعمق.", duration: "4–6 جلسات" },
    ],
    upcomingEyebrow: "الورشات القادمة",
    upcomingTitle: "جلسات مفتوحة للتنسيق مع الكليات والجهات المستضيفة.",
    upcomingDesc: "تُعلن التواريخ والأماكن تدريجيًا بحسب الاتفاق مع الجهة المستضيفة. للتنسيق المبكر يمكنكم التواصل مباشرةً.",
    requestHost: "طلب استضافة ورشة",
    detailsReg: "تفاصيل والتسجيل",
    upcoming: [
      { format: "محاضرة توعوية", title: "مقدّمة عملية في الذكاء الاصطناعي", theme: "استعراض لأدوات الذكاء الاصطناعي المجانية واستخداماتها في الدراسة والبحث.", audience: "طلاب جامعيون · مفتوحة للكليات", date: "يُعلن قريبًا", location: "داخل الجامعة — عبر التنسيق مع الكلية" },
      { format: "ورشة تطبيقية", title: "أدوات الذكاء الاصطناعي في البحث العلمي", theme: "تطبيق عملي على أدوات البحث والتلخيص وتنظيم المراجع.", audience: "طلاب دراسات عليا وباحثون", date: "يُعلن قريبًا", location: "داخل الجامعة / مركز مجتمعي" },
      { format: "ورشة تطبيقية", title: "الذكاء الاصطناعي في الحياة اليومية", theme: "جلسة مفتوحة للعامّة حول الاستخدامات العملية والمسؤولة لأدوات الذكاء الاصطناعي.", audience: "عام · منظمات ومراكز مجتمعية", date: "يُعلن قريبًا", location: "مركز مجتمعي / جهة مستضيفة" },
    ],
    seriesEyebrow: "السلاسل التعليمية",
    seriesTitle: "مسارات تدريبية متعدّدة الجلسات.",
    seriesDesc: "مناسبة للكليات والجهات التي ترغب بتغطية أعمق وأكثر تتابعًا، مع جلسات تطبيقية بين المحاضرات.",
    seriesCta: "طلب السلسلة داخل كليّتكم",
    series: [
      { title: "المسار الجامعي للذكاء الاصطناعي", theme: "سلسلة تدريبية متكاملة تغطّي أساسيات الذكاء الاصطناعي وتطبيقاته في الدراسة والبحث، بتدرّج واضح عبر عدّة جلسات.", audience: "طلاب جامعيون · كليات مستضيفة", duration: "4–6 جلسات", format: "سلسلة تدريبية" },
      { title: "مسار الأدوات التطبيقية", theme: "سلسلة عملية قصيرة تركّز على أدوات محدّدة (كتابة، بحث، عروض تقديمية) مع تمارين تطبيقية بين الجلسات.", audience: "طلاب · باحثون · معلمون", duration: "4 جلسات", format: "سلسلة تدريبية" },
    ],
    pastEyebrow: "ورشات سابقة",
    pastTitle: "نشاط ميداني منذ انطلاق المبادرة.",
    pastDesc: "نفّذ فريق SAS 10 محاضرات حتّى الآن — 4 داخل جامعة حلب و6 خارجها — بمشاركة قرابة 1000 شخص.",
    past: [
      { title: "سلسلة محاضرات جامعة حلب", location: "جامعة حلب — عدّة كليات", audience: "طلاب جامعيون", note: "4 محاضرات · ضمن المحاضرات الجامعية الرئيسية", format: "محاضرة توعوية" },
      { title: "محاضرات خارج الجامعة", location: "مراكز مجتمعية — مدينة حلب ومحيطها", audience: "عام · مهتمّون من خارج الجامعة", note: "6 محاضرات مجتمعية", format: "محاضرة توعوية" },
    ],
    viewFullImpact: "عرض الأثر الكامل",
    hostEyebrow: "استضافة ورشة · تعاون مؤسّسي",
    hostTitle: "هل تمثّل كلية أو جامعة أو منظمة أو مركزًا مجتمعيًا؟",
    hostBody: "يسعدنا التنسيق معكم لتنفيذ محاضرة توعوية، أو ورشة تطبيقية، أو سلسلة تدريبية كاملة داخل مؤسّستكم. الاستضافة بدون أي رسوم، وباستخدام أدوات مجانية بالكامل.",
    hostPoints: ["تنسيق مباشر مع الكلية أو الجهة", "محتوى عربي مبسّط وعملي", "مرونة في اختيار الصيغة والمدّة", "مناسبة للجامعات والمنظمات والمراكز"],
    hostCtaPrimary: "اطلب استضافة ورشة",
    hostCtaGhost: "للتعاون المؤسّسي",
  },
  en: {
    eyebrow: "Workshops",
    title: "Workshops & educational programmes",
    lead: "The Syrian AI Society runs a practical educational model inside universities and community centres, delivered in multiple formats that suit faculties, organisations, and hosts — and always using free tools.",
    modelEyebrow: "Delivery model",
    modelTitle: "Three formats for delivering educational sessions.",
    modelDesc: "Each session is tailored to the faculty or host's needs — from a single awareness lecture to an integrated training series.",
    formats: [
      { icon: BookOpen, label: "Awareness lecture", desc: "A single introductory session on AI and its practical tools — suitable for faculties looking for a fast, clear overview.", duration: "One session" },
      { icon: Presentation, label: "Practical workshop", desc: "A hands-on session focused on using specific free tools in study, research, and daily tasks.", duration: "Focused session" },
      { icon: Layers, label: "Training series", desc: "An integrated multi-session track (4–6 sessions) designed for faculties and centres wanting deeper coverage.", duration: "4–6 sessions" },
    ],
    upcomingEyebrow: "Upcoming workshops",
    upcomingTitle: "Sessions open for coordination with faculties and hosts.",
    upcomingDesc: "Dates and venues are announced gradually in coordination with the host. Reach out early to plan ahead.",
    requestHost: "Request to host",
    detailsReg: "Details & register",
    upcoming: [
      { format: "Awareness lecture", title: "A practical intro to AI", theme: "An overview of free AI tools and their use in study and research.", audience: "University students · open to faculties", date: "Announced soon", location: "On-campus — via coordination with the faculty" },
      { format: "Practical workshop", title: "AI tools for academic research", theme: "Hands-on session on search, summarisation, and reference management.", audience: "Postgraduates & researchers", date: "Announced soon", location: "On-campus / community centre" },
      { format: "Practical workshop", title: "AI in daily life", theme: "An open community session on the practical and responsible uses of AI tools.", audience: "General · organisations & community centres", date: "Announced soon", location: "Community centre / host" },
    ],
    seriesEyebrow: "Training series",
    seriesTitle: "Multi-session training tracks.",
    seriesDesc: "Designed for faculties and hosts wanting deeper, sequential coverage — with practical exercises between lectures.",
    seriesCta: "Request this series inside your faculty",
    series: [
      { title: "The university AI track", theme: "An integrated series covering AI fundamentals and their applications in study and research, progressing clearly across multiple sessions.", audience: "University students · hosting faculties", duration: "4–6 sessions", format: "Training series" },
      { title: "Applied tools track", theme: "A short, practical series focused on specific tools (writing, research, presentations) with exercises between sessions.", audience: "Students · researchers · educators", duration: "4 sessions", format: "Training series" },
    ],
    pastEyebrow: "Past workshops",
    pastTitle: "On-the-ground activity since launch.",
    pastDesc: "The SAS team has delivered 10 lectures so far — 4 at the University of Aleppo and 6 elsewhere — reaching roughly 1,000 participants.",
    past: [
      { title: "University of Aleppo lecture series", location: "University of Aleppo — multiple faculties", audience: "University students", note: "4 lectures · within the main university series", format: "Awareness lecture" },
      { title: "Off-campus lectures", location: "Community centres — Aleppo and surroundings", audience: "General · off-campus audiences", note: "6 community lectures", format: "Awareness lecture" },
    ],
    viewFullImpact: "See full impact",
    hostEyebrow: "Host a workshop · Institutional partnership",
    hostTitle: "Represent a faculty, university, organisation, or community centre?",
    hostBody: "We'd be glad to coordinate an awareness lecture, a practical workshop, or a full training series inside your institution. Hosting is free of charge, and all tools used are entirely free.",
    hostPoints: ["Direct coordination with the faculty or host", "Simplified, practical Arabic-first content", "Flexibility in format and duration", "Suitable for universities, orgs, and centres"],
    hostCtaPrimary: "Request to host",
    hostCtaGhost: "Institutional partnerships",
  },
};

export default function Workshops() {
  const { lang } = useLanguage();
  const c = C[lang];

  return (
    <>
      <PageHero eyebrow={c.eyebrow} title={c.title} lead={c.lead} />

      <section className="sas-section" data-testid="workshops-model">
        <div className="sas-container">
          <SectionHeading eyebrow={c.modelEyebrow} title={c.modelTitle} description={c.modelDesc} />
          <div className="sas-grid-3 mt-10">
            {c.formats.map((f, i) => (
              <div key={f.label} className="sas-card" data-testid={`model-card-${i}`}>
                <div className="w-11 h-11 rounded-full flex items-center justify-center mb-5" style={{ background: "var(--sas-accent-soft)", color: "var(--sas-accent)" }} aria-hidden>
                  <f.icon size={20} />
                </div>
                <h3 className="sas-h3">{f.label}</h3>
                <p className="sas-body mt-3 text-[15px]">{f.desc}</p>
                <div className="mt-5 text-xs text-[color:var(--sas-ink-2)] tracking-wide">{f.duration}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <div className="sas-divider" />

      <section className="sas-section" data-testid="workshops-upcoming">
        <div className="sas-container">
          <div className="flex flex-wrap justify-between items-end gap-6">
            <SectionHeading eyebrow={c.upcomingEyebrow} title={c.upcomingTitle} description={c.upcomingDesc} />
            <LocalizedLink to="/contact/host-workshop" className="sas-btn-link">{c.requestHost} <NextArrow size={16} /></LocalizedLink>
          </div>
          <div className="sas-grid-3 mt-10">
            {c.upcoming.map((w, i) => (
              <WorkshopCard
                key={w.title}
                status="upcoming"
                format={w.format}
                title={w.title}
                theme={w.theme}
                audience={w.audience}
                date={w.date}
                location={w.location}
                ctaLabel={c.detailsReg}
                ctaTo="/contact/host-workshop"
                testId={`upcoming-${i}`}
              />
            ))}
          </div>
        </div>
      </section>

      <div className="sas-divider" />

      <section className="sas-section" data-testid="workshops-series">
        <div className="sas-container">
          <SectionHeading eyebrow={c.seriesEyebrow} title={c.seriesTitle} description={c.seriesDesc} />
          <div className="sas-grid-2 mt-10">
            {c.series.map((s, i) => (
              <article key={s.title} className="sas-card" data-testid={`series-${i}`}>
                <div className="flex items-center justify-between gap-3 mb-4">
                  <span className="sas-chip">{s.format}</span>
                  <span className="text-xs text-[color:var(--sas-ink-2)]">{s.duration}</span>
                </div>
                <h3 className="sas-h3">{s.title}</h3>
                <p className="sas-body mt-3 text-[15px]">{s.theme}</p>
                <div className="mt-5 text-sm text-[color:var(--sas-ink-2)]">{s.audience}</div>
                <LocalizedLink to="/contact/host-workshop" className="sas-btn-link mt-6 inline-flex">
                  {c.seriesCta} <NextArrow size={15} />
                </LocalizedLink>
              </article>
            ))}
          </div>
        </div>
      </section>

      <div className="sas-divider" />

      <section className="sas-section" data-testid="workshops-past">
        <div className="sas-container">
          <SectionHeading eyebrow={c.pastEyebrow} title={c.pastTitle} description={c.pastDesc} />
          <div className="mt-10 border-t border-[color:var(--sas-line)]">
            {c.past.map((p) => (
              <div key={p.title} className="grid grid-cols-1 md:grid-cols-[1fr_1fr_auto] gap-4 md:gap-8 items-start md:items-center py-6 border-b border-[color:var(--sas-line)]">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="sas-chip sas-chip-neutral">{p.format}</span>
                  </div>
                  <h3 className="sas-h3">{p.title}</h3>
                </div>
                <div className="text-sm text-[color:var(--sas-ink-2)] space-y-1">
                  <div>{p.location}</div>
                  <div>{p.audience}</div>
                </div>
                <div className="text-sm font-medium text-[color:var(--sas-ink)]">{p.note}</div>
              </div>
            ))}
          </div>
          <div className="mt-8">
            <LocalizedLink to="/impact" className="sas-btn-link">{c.viewFullImpact} <NextArrow size={16} /></LocalizedLink>
          </div>
        </div>
      </section>

      <section className="sas-section-sm bg-[color:var(--sas-accent-soft)] border-y border-[color:var(--sas-line)]" data-testid="workshops-host">
        <div className="sas-container">
          <div className="grid lg:grid-cols-[1.5fr_1fr] gap-8 items-center">
            <div>
              <div className="sas-eyebrow mb-3">{c.hostEyebrow}</div>
              <h3 className="sas-h2">{c.hostTitle}</h3>
              <p className="sas-body mt-3 max-w-2xl">{c.hostBody}</p>
              <ul className="mt-5 grid sm:grid-cols-2 gap-y-2 gap-x-6 text-sm text-[color:var(--sas-ink-2)] max-w-xl">
                {c.hostPoints.map((p) => (
                  <li key={p} className="flex items-center gap-2">
                    <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--sas-accent)]" />
                    {p}
                  </li>
                ))}
              </ul>
            </div>
            <div className="flex flex-col gap-3 lg:items-end">
              <LocalizedLink to="/contact/host-workshop" className="sas-btn sas-btn-primary" data-testid="host-cta">{c.hostCtaPrimary}</LocalizedLink>
              <LocalizedLink to="/contact/partnership" className="sas-btn sas-btn-ghost">{c.hostCtaGhost}</LocalizedLink>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
